import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import { NForm, NCard, NSpace, NFormItem, NInputNumber, NSelect, NDataTable, NRadio, NRadioGroup } from 'naive-ui'
import helper from "@/helper";
import EmbedCode from "@/components/embed";

const INPUT_MODE_DIAMETER = 'd';
const INPUT_MODE_RADIUS = 'r';
const INPUT_MODE_CIRCUMFERENCE = 'c';

createApp({
    components: { NForm, NCard, NSpace, NFormItem, NInputNumber, NSelect, NDataTable, NRadio, NRadioGroup, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            unit: 'mm',
            inputMode: 'd',
            inputModes: [
                {
                    value: INPUT_MODE_DIAMETER,
                    label: 'Diameter'
                },
                {
                    value: INPUT_MODE_RADIUS,
                    label: 'Radius'
                },
                {
                    value: INPUT_MODE_CIRCUMFERENCE,
                    label: 'Circumference'
                }
            ],
            input: 100,
            units: helper.lengthUnitsGrouped,
            tableColumns: [
                {
                    title: 'Unit',
                    key: 'unit'
                },
                {
                    title: 'Result',
                    key: 'result'
                }
            ]
        }
    },
    computed: {

        result() {
            if (this.inputMode === INPUT_MODE_DIAMETER) {
                return Math.PI * Math.pow(this.input, 2) / 4;
            }
            if (this.inputMode === INPUT_MODE_RADIUS) {
                return Math.PI * Math.pow(this.input, 2);
            }
            if (this.inputMode === INPUT_MODE_CIRCUMFERENCE) {
                return Math.PI * Math.pow(this.input / Math.PI / 2, 2);
            }
            return null;
        },

        resultTable() {
            const data = [];

            for (let unit in helper.conv.length) {
                data.push({
                    unit: unit + '²',
                    result: (this.result * Math.pow(helper.conv.length[this.unit], 2)) / Math.pow(helper.conv.length[unit], 2)
                });
            }

            return data;
        },

    }
}).mount('#app')
